import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["field", "total"]
    static values = {
        headcount: { type: Number, default: 0 }
    }

    connect() {
        this.initializeMutationObserver();
        this.calculate();
    }

    disconnect() {
        if (this.mutationObserver) this.mutationObserver.disconnect();
    }

    calculate() {
        const total = this.calculateTotal();
        this.updateTotalDisplay(total);
    }

    // Private methods
    initializeMutationObserver() {
        this.mutationObserver = new MutationObserver(() => this.calculate());
        this.mutationObserver.observe(this.element, {
            childList: true,
            subtree: true  // Add this to watch nested elements
        });
    }

    calculateTotal() {
        return this.fieldTargets.reduce((total, field) => {
            if (this.isFieldActive(field)) {
                const value = Number(field.value) || 0;
                return total + value;
            }
            return total;
        }, 0);
    }

    isFieldActive(field) {
        const wrapper = field.closest('.nested-form-wrapper');
        const destroyField = wrapper?.querySelector('input[name*="_destroy"]');
        return !destroyField || destroyField.value !== '1';
    }

    updateTotalDisplay(total) {
        this.totalTarget.value = total;
        
        if (this.shouldUpdateValidation()) {
            const difference = this.headcountValue - total;
            this.updateValidationClasses(difference === 0);
        }
    }

    shouldUpdateValidation() {
        return this.totalTarget.classList.contains('red-text') || this.totalTarget.classList.contains('green-text');
    }

    updateValidationClasses(isValid) {
        const validClasses = ['green-text', 'valid'];
        const invalidClasses = ['red-text', 'invalid'];

        if (isValid) {
            this.totalTarget.classList.remove(...invalidClasses);
            this.totalTarget.classList.add(...validClasses);
        } else {
            this.totalTarget.classList.remove(...validClasses);
            this.totalTarget.classList.add(...invalidClasses);
        }
    }
}